<div class="notifications-alerts">
  @for (alert of this.notifications; track alert) {
  <alert [message]="alert.message" [id]="alert.id" [url]="alert.url" />
  }
</div>